import { useNavigate } from "react-router-dom";
import { useMemo, useEffect } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import { Button } from "@atd/components";
import {
  useGetAllAnnouncementsQuery,
  useDeleteAnnouncementMutation,
  useUpdateAnnouncementStatusMutation,
} from "@atd/features/dashboard";

import DataTable from "../Communications/DataTable";

function AnnouncementNameCell({ value }) {
  return (
    <>
      <div className="title1 bl-cont">{value.title}</div>
      <div
        className="cont1"
        dangerouslySetInnerHTML={{ __html: value.message }}
      />
    </>
  );
}

function Announcements() {
  const navigate = useNavigate();

  const {
    data: allAnnouncement,
    isLoading,
    error,
  } = useGetAllAnnouncementsQuery();
  const [updateStatus, { data: updatedAnnouncementData, isSuccess }] =
    useUpdateAnnouncementStatusMutation();
  const [deleteAnnouncement] = useDeleteAnnouncementMutation();

  const { message } = updatedAnnouncementData || {};

  useEffect(() => {
    if (isSuccess) {
      toast.success(message);
    }
  }, [isSuccess, message]);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "item",
        Cell: AnnouncementNameCell,
      },
      {
        Header: "From",
        accessor: "from",
      },
      {
        Header: "To",
        accessor: "to",
      },
      {
        Header: "Status",
        accessor: "is_active",
      },
    ],
    [],
  );

  const data = useMemo(() => {
    const announcements = allAnnouncement
      ? allAnnouncement.map((item) => ({
          item,
          id: item.id,
          from: moment(item.from_date_time).format("MM-DD-YYYY"),
          to: moment(item.to_date_time).format("MM-DD-YYYY"),
          is_active: item.is_active ? "Actived" : "Deactivated",
        }))
      : [];
    return announcements;
  }, [allAnnouncement]);

  return (
    <DataTable
      title="All Announcements"
      isLoading={isLoading}
      error={error}
      action={
        <Button
          label="Create Announcement"
          variant="primary"
          icon="plus"
          onClick={() => navigate("/settings/announcements/new")}
        />
      }
      columns={columns}
      data={data}
      onEdit={(id) => navigate(`/settings/announcements/${id}`)}
      onDelete={(id) => deleteAnnouncement(id)}
      actions={({ value }) => {
        const {
          item: { id, is_active },
        } = value;
        return [
          {
            name: is_active ? "Make a Deactive" : "Make a Active",
            value: "activate",
            onClick: () => {
              updateStatus({ id, isActive: is_active });
            },
          },
        ];
      }}
    />
  );
}

export default Announcements;
